import React, { useState, useEffect } from 'react'
import SamplecsvFile from '../../../maketingimages/singular.csv'
import GoogleSampleCsv from '../../../../../../images/GoogleSampleCsv.csv'
import { SaveSingularLogsCSV, getLatestEventTimestampAPI, getAllSingularcsvLogsByDate, SaveGoogleLogsCSV } from '../../actioncreator'
import Loader from '../../../../../presentationals/Loader/Loader.component';
import PopUp from '../../../../../presentationals/Popup/Popup.component';
import moment from 'moment';

const typeList = [
  { name: "Singular", CODE: "Singular" },
  { name: "Google", CODE: "Google" },
]


export default function Singular({ admin }) {
  const [timeStampData, settimeStampData] = useState({})
  const [errorPopup, setErrorPopup] = useState(false)
  const [csvFile, setCsvFile] = useState(null);
  const [nameOfFile, setNameOfFile] = useState('');
  const [csvData, setCsvData] = useState('');
  const [csvSaveData, setSaveData] = useState('');
  const [loaderState, setLoaderState] = useState(false);
  const [popupState, setPopupState] = useState(false);
  const [popupStatus, setPopupStatus] = useState('');
  const [logsPopup, setLogsPopup] = useState(false)
  const [uploadType, setUploadType] = useState("")

  useEffect(() => {
    getLatestEventTimestampAPI(callback => {
      console.log(callback)
      if (callback && callback?.message == 'success') {
        settimeStampData(callback?.data)
      }
    })
  }, []);

  const changeHandler = (e) => {
    setCsvFile(e.target.files[0]);
    setNameOfFile(e.target.files[0].name);
  };

  const submitHandler = () => {
    setLoaderState(true);
    if (uploadType == "Singular") {
      SaveSingularLogsCSV(csvFile, admin?.emailId, (callback) => {
        console.log(csvFile);
        console.log(callback);
        if (callback && callback?.message == 'success' && callback?.data == null) {
          setCsvData(callback?.data);
          setLoaderState(false);
          setPopupState(true)
          setPopupStatus('CSV uploaded Successfully')
        } else if (callback && callback?.message == 'success') {
          setCsvData(callback?.data);
          setLoaderState(false);
          setPopupState(true)
          setPopupStatus('Errors in CSV File Uploaded')
        } else if (callback && callback?.message == 'failure') {
          setPopupState(true)
          setPopupStatus(callback?.data || '')
        } else {
          setPopupState(true)
          setPopupStatus('Error Uploading CSV File')
        }
        setLoaderState(false);
      });
    }

    if (uploadType == "Google") {
      SaveGoogleLogsCSV(null, admin?.emailId, "google", csvFile, callback => {
        if (callback && callback?.message == 'success' && callback?.data == null) {
          setCsvData(callback?.data);
          setLoaderState(false);
          setPopupState(true)
          setPopupStatus('CSV uploaded Successfully')
        } else if (callback && callback?.message == 'success') {
          setCsvData(callback?.data);
          setLoaderState(false);
          setPopupState(true)
          setPopupStatus('Errors in CSV File Uploaded')
        } else if (callback && callback?.message == 'failure') {
          setPopupState(true)
          setPopupStatus(callback?.data || '')
        } else {
          setPopupState(true)
          setPopupStatus('Error Uploading CSV File')
        }
        setLoaderState(false);
      })
    }
  };


  const closePopup = () => {
    setPopupState(false)
  }
  const removePopup = () => {
    setTimeout(() => {
      setPopupState(false)
    }, 5000);
  }

  const handleSelectPlatform = (e) => {
    setUploadType(e.target.value)
  }

  return (
    <>
      {loaderState && <Loader />}
      {popupState ? <PopUp popupStatus={popupStatus} closePopup={closePopup} /> : ""}
      <div className='container-fluid' style={{ marginTop: '12%' }}>
        <div className="row">


        </div>
        <div className='row'>
          <div className="col-sm-2 col-xs-12" style={{ marginTop: '23px' }}>
            <label htmlFor="">Select Platform</label>
            <select className='form-control' value={uploadType} onChange={(e) => handleSelectPlatform(e)}>
              <option value={""}>Select Option</option>
              {
                typeList?.length > 0 ? typeList?.map((val, id) => {
                  return (
                    <option value={val?.CODE}>{val?.name}</option>
                  )
                })
                  : ""}
            </select>
          </div>
          <div className="col-sm-2 col-xs-12" style={{ marginTop: '50px' }}>
            <div>
              {
                csvData && csvData?.notSaved?.length > 0 ?
                  <button className='btn btn-primary' style={{ padding: '11px' }} onClick={() => setErrorPopup(true)}>
                    Errors in CSV
                  </button>
                  : ''}
              <button className='btn btn-primary' style={{ padding: '11px' }} onClick={() => setLogsPopup(true)}>
                Logs
              </button>
            </div>
          </div>

          <div className=" col-lg-4 col-sm-6 col-xs-12" style={{ float: 'inline-end', marginTop: '10px' }}>
            <div className='count-div' style={{ display: 'flex' }}>
              <div className="btn-count-new text-center" style={{ marginRight: '10px' }}><div style={{ fontSize: '14px', color: '#1D3557', fontWeight: '700' }}>LATEST EVENT TIMESTAMP <br></br><br></br> </div> <span style={{ color: '#2B78FF', fontSize: '20px', fontWeight: 700 }}>{timeStampData?.latestEventTimestamp || '-'}</span></div>
              <div className="btn-count-new text-center"><div style={{ fontSize: '14px', color: '#1D3557', fontWeight: '700' }}>LATEST ADDED ON <br></br><br></br> </div> <span style={{ color: '#2B78FF', fontSize: '20px', fontWeight: 700 }}>{timeStampData?.latestAddedOn || '-'}</span></div>
            </div>
          </div>
        </div>
        {
          uploadType !== "" ?
            <div className="row">
              <div className='col-sm-6 col-xs-12'>
                <div className='upload-csv text-center' style={{ marginTop: '53px' }}>
                  <label className='' htmlFor='formFileLg'>
                    <i className='bi bi-cloud-arrow-up-fill me-3'></i>
                    <span className='align-middle'>
                      {nameOfFile ? (
                        nameOfFile
                      ) : (
                        <>
                          <i className='fa fa-cloud-upload' style={{ fontSize: '20px', marginTop: '10px' }}></i>
                          &nbsp;&nbsp; Click here to Upload CSV File
                        </>
                      )}
                    </span>
                  </label>
                  <input
                    className='form-control form-control-lg'
                    id='formFileLg'
                    accept={['.csv','.xlsx','.xlx','.xlxs']}
                    type='file'
                    onChange={(e) => {
                      changeHandler(e);
                    }}
                  />
                </div>
              </div>
              <div className='' style={{ display: 'flex' }}>
                <div >
                  {nameOfFile && (
                    <div className='text-center' style={{ marginTop: '50px', }}>
                      <button className='btn btn-primary' style={{ padding: '15px' }} onClick={submitHandler}>
                        Submit
                      </button>
                    </div>
                  )}
                </div>
                &nbsp;&nbsp;
                <div >

                  <a href={uploadType == "Singular" ? SamplecsvFile : uploadType == "Google" ? GoogleSampleCsv : ""}>
                    <button className='btn btn-primary' style={{ marginBottom: '20px', marginTop: '50px', padding: '15px' }}>
                      <i className='fa fa-cloud-download'></i>&nbsp;&nbsp;Download CSV Sample File{' '}
                    </button>
                  </a>
                </div>

              </div>
            </div>
            : ""}

        <div className='row'>
          {errorPopup ? (
            <div>
              <div className="background-blur" onClick={(e) => setErrorPopup(false)}></div>
              <div className="popup-main small-popup container-fluid dbl-border" style={{ maxWidth: '1000px', width: '100%' }}>
                <div className="row from-group">
                  <div className="col-xs-12">
                    <h4 className="text-center">Errors In Uploaded Csv</h4>
                  </div>
                </div>
                <div style={{ overflowX: 'auto', maxHeight: '500px' }}>
                  <div className="row from-group text-center" style={{ padding: '15px' }} >
                    <table className='phocket-table'>
                      <thead style={{ position: 'sticky', top: '0', zIndex: '1', width: '100%' }}>
                        <tr>
                          <th className='text-center'>S.No.</th>
                          <th className='text-center'>Line No.</th>
                          <th className='text-center'>Error</th>
                        </tr>
                      </thead>
                      <tbody >
                        {csvData?.notSaved?.map((csvKey, index) => {
                          let [before, after] = csvKey.split(/:(.+)/)
                          return (
                            <tr key={index} >
                              <td>{index + 1}</td>
                              <td>{before}</td>
                              <td>{after}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : ''}

        </div>
        {
          logsPopup ?
            <div className='row'>

              <LogsComponent setLogsPopup={setLogsPopup} setLoaderState={setLoaderState} />

            </div>
            : ''}

      </div>
    </>
  )
}


const LogsComponent = ({ setLogsPopup, setLoaderState }) => {
  const [payload, setPayload] = useState({ start: moment(new Date()).format("YYYY-MM-DD"), end: moment(new Date()).format("YYYY-MM-DD") })
  const [listData, setListData] = useState([])
  const [FilteredlistData, setFilteredListData] = useState([])
  const [currentPage, setcurrentPage] = useState(1)
  const handleCHange = (e, type) => {
    setPayload((prev) => ({
      ...prev,
      [type]: e.target.value
    }))
  }

  useEffect(() => {

    getAllSingularcsvLogsByDateFn(payload)
  }, [])

  const getAllSingularcsvLogsByDateFn = (payload) => {
    setLoaderState(true)
    getAllSingularcsvLogsByDate(moment(payload?.start).format("DD-MM-YYYY"), moment(payload?.end).format("DD-MM-YYYY"), callback => {
      setLoaderState(false)
      setFilteredListData(callback?.data)
    })
  }

  return (
    <>
      <div>
        <div className="background-blur" onClick={(e) => setLogsPopup(false)}></div>
        <div className="popup-main small-popup container-fluid dbl-border" style={{ maxWidth: '1000px', width: '100%' }}>
          <div className="row from-group">
            <div className="col-xs-12">
              <h4 className="text-center">Logs</h4>
            </div>
          </div>
          <div className='row'>
            <div className="col-sm-2 col-xs-12">
              <label htmlFor="">Start Date</label>
              <input type='date' value={payload?.start} className='form-control' onChange={(e) => handleCHange(e, "start")} />
            </div>
            <div className="col-sm-2 col-xs-12">
              <label htmlFor="">End Date</label>
              <input type='date' value={payload?.end} className='form-control' onChange={(e) => handleCHange(e, "end")} />
            </div>
            <div className="col-sm-2 col-xs-12">
              <button className='btn btn-primary' style={{ marginTop: '28px' }} onClick={() => { getAllSingularcsvLogsByDateFn(payload); setcurrentPage(1); }}>Apply</button>
            </div>
          </div>
          <div style={{ overflowX: 'auto', maxHeight: '500px' }}>
            <div className="row from-group text-center" style={{ padding: '15px', maxHeight: '400px', overflowY: 'auto' }} >
              <table className='phocket-table'>
                <thead style={{ position: 'sticky', top: '0', zIndex: '1', width: '100%' }}>
                  <tr>
                    <th className='text-center'>S.No.</th>
                    <th className='text-center'>Added By</th>
                    <th className='text-center'>CSV Type</th>
                    <th className='text-center'>Added On</th>
                  </tr>
                </thead>
                <tbody >
                  {FilteredlistData?.length > 0 ? FilteredlistData?.map((csvKey, index) => {

                    return (
                      <tr key={index} >
                        <td>{index + 1}</td>
                        <td>{csvKey?.added_By}</td>
                        <td>{csvKey?.csv_Type}</td>
                        <td>{csvKey?.added_On}</td>
                      </tr>
                    )
                  }) : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}